<template>
  <div :class="['admin-layout', themeClass]">
    <!-- Sidebar fijo -->
    <AdminSidebar class="admin-sidebar" />

    <!-- Contenido principal -->
    <div class="main-content">
      <AdminTopbar class="admin-topbar" />

      <main class="content-area">
        <template v-if="hasError">
          <div class="alert alert-danger" role="alert">
            <h5>Error al renderizar la vista</h5>
            <p class="mb-0">{{ errorMessage }}</p>
            <small class="text-muted">Revisa la consola para más detalles.</small>
          </div>
        </template>
        <template v-else>
          <router-view />
        </template>
      </main>
    </div>
  </div>
</template>

<script>
import AdminSidebar from '@/components/layout/AdminSidebar.vue'
import AdminTopbar from '@/components/layout/AdminTopbar.vue'
import themeManager from '@/store/theme'

export default {
  name: 'AdminLayout',
  components: {
    AdminSidebar,
    AdminTopbar
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  }
  ,
  data() {
    return {
      hasError: false,
      errorMessage: ''
    }
  },
  errorCaptured(err, vm, info) {
    // Registrar el error y evitar que se propague para que la app no se rompa
    // Retornar false detiene la propagación del error a componentes padres
    console.error('Error capturado en AdminLayout:', err, info, vm)
    this.hasError = true
    this.errorMessage = (err && err.message) ? err.message : String(err)
    return false
  }
}
</script>

<style>
.admin-layout {
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-main);
  transition: background-color 0.3s ease;
}

/* Sidebar */
.admin-sidebar {
  width: 250px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: var(--sidebar-bg);
  border-right: 1px solid var(--border-color);
  z-index: 1000;
  box-shadow: var(--shadow-sm);
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Contenido principal */
.main-content {
  margin-left: 250px;
  width: calc(100% - 250px);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-main);
  transition: background-color 0.3s ease;
}

/* Topbar */
.admin-topbar {
  flex: 0 0 auto;
  background-color: var(--header-bg);
  border-bottom: 1px solid var(--header-border);
  box-shadow: var(--shadow-sm);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

/* Vistas cargadas */
.content-area {
  flex: 1 1 auto;
  overflow: visible;
  padding: 24px;
  background-color: var(--secondary-bg-main);
  color: var(--text-primary);
  box-sizing: border-box;
  margin: 16px;
  border: 1px solid var(--border-main);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  transition: background-color 0.3s ease, color 0.3s ease;
}
</style>
